import { render } from "./caizhongpeizhi.vue?vue&type=template&id=f008f8c4&scoped=true"
import script from "./caizhongpeizhi.vue?vue&type=script&lang=js"
export * from "./caizhongpeizhi.vue?vue&type=script&lang=js"

import "./caizhongpeizhi.vue?vue&type=style&index=0&id=f008f8c4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\33043\\Desktop\\new\\pc_admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f008f8c4"]])

export default __exports__